export default "__VITE_ASSET__DJPWS695__"